import { createContext, useContext } from 'react';
import { invContextType } from '../types/inv';

const InvContext = createContext<invContextType | undefined>(undefined);

export const useInvContext = (): invContextType => {
    const context = useContext(InvContext);
    if (!context) {
        throw new Error('useInvContext must be used within an InvProvider');
    }
    return context;
};

export default InvContext;
